import axios from 'axios';
import { useEffect, useState } from 'react';
import { startRegistration, startAuthentication, browserSupportsWebAuthn, platformAuthenticatorIsAvailable, browserSupportsWebAuthnAutofill, WebAuthnAbortService } from '@simplewebauthn/browser';
export const supportsPasskeys = () => browserSupportsWebAuthn();
const deviceAvailable = async () => { try { return await platformAuthenticatorIsAvailable() && await browserSupportsWebAuthnAutofill(); } catch { return false; } };
export function useDevicePasskey() {
    const [available,setAvailable]=useState(null);
    useEffect(()=>{let active=true;deviceAvailable().then(value=>{if(active)setAvailable(value);}).catch(()=>{});return()=>{active=false;};},[]);
    return available;
}
async function requireThisDevice() {
    if(!await deviceAvailable()) throw Object.assign(new Error(),{code:'DEVICE_UNAVAILABLE'});
}
export async function addPasskey(name) {
    await requireThisDevice();
    const { data: optionsJSON } = await axios.post('/api/passkeys/register/options');
    const response = await startRegistration({ optionsJSON });
    await axios.post('/api/passkeys/register/verify', { response, name });
}
export async function passkeyLogin(remember) {
    await requireThisDevice();
    const { data: optionsJSON } = await axios.post('/api/passkeys/login/options', { remember });
    const response = await startAuthentication({ optionsJSON });
    return (await axios.post('/api/passkeys/login/verify', { response })).data;
}
export function securityError(error) {
    if(error.code === 'DEVICE_UNAVAILABLE') return 'Easy sign-in is unavailable in this browser. Please use your password; you can set it up later on a supported device.';
    if (error.name === 'NotAllowedError' || error.code === 'ERROR_CEREMONY_ABORTED') return 'Nothing was changed. Use your password for now. To set up easy sign-in, sign in with your password and open Account security.';
    return error.response?.data?.error || 'Unable to use this passkey. Try again or use your password.';
}

// Conditional mediation only: never open a modal merely because the login form is visible.
export function beginPasskeyAutofill({ remember, onSelected, onSuccess, onError }) {
    let active = true;
    const controller = new AbortController();
    (async () => {
        try {
            if (!await deviceAvailable() || !active) return;
            const { data: optionsJSON } = await axios.post('/api/passkeys/login/options', { remember }, { signal: controller.signal });
            if (!active) return;
            const response = await startAuthentication({ optionsJSON, useBrowserAutofill: true });
            if (!active) return;
            onSelected();
            const { data } = await axios.post('/api/passkeys/login/verify', { response }, { signal: controller.signal });
            if (active) onSuccess(data);
        } catch (error) {
            // Missing credentials, unsupported autofill and cancellation simply leave password login available.
            if (active && error.response?.config?.url?.includes('/verify')) onError(error);
        }
    })();
    return () => { active = false; controller.abort(); WebAuthnAbortService.cancelCeremony(); };
}
